import { Button } from '@amzn/stencil-react-components/button';
import { Select } from '@amzn/stencil-react-components/select';
import { Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { updateJourneyContent } from '../../actions/journeyDetailsAction';
import { CREATE_CONTENT_PAGE } from '../../constants/routesConstant';
import { templateListSelector } from '../../selectors/selectors';
import { buildTemplateListOption, templateListFilter } from '../../util/campaign/campaignUtils';
import { accessById as templateValueAccessor } from '../../util/journey/journeyUtils';
import TemplateRenderOption from './dropdown-option/TemplateRenderOption';

const SelectTemplate = ({ data, id, readonly }) => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const templateList = useSelector(templateListSelector);
  const buildTemplateList = buildTemplateListOption(templateList);

  const templateFilterOption = searchText => templateListFilter(searchText, buildTemplateList);

  const messageTemplateList = templateList?.reduce((acc, cur) => {
    acc.push(cur.messageTemplateName);
    return acc;
  }, []);

  const onTemplateSelect = e => {
    const value = {
      name: e.name ?? '',
      id: e.id ?? '',
    };
    dispatch(updateJourneyContent(id, value));
  };

  return (
    <>
      <Label key={`tmpl-select-label-${id}`} fontSize="T300" fontWeight="bold">
        <FormattedMessage id="app.selectTemplate.content" />
      </Label>
      <Spacer key={`tmpl-spacer-${id}`} height="15px" />
      <Select
        error={false}
        key={`tmpl-select-drop-${id}`}
        data-testid="select-template"
        isMulti={false}
        isSearchable={true}
        disabled={readonly}
        onChange={e => onTemplateSelect(e)}
        options={messageTemplateList}
        valueAccessor={templateValueAccessor}
        renderOption={TemplateRenderOption}
        filterOptions={templateFilterOption}
        noOptionsText="No options found."
        placeholder={formatMessage({ id: 'app.selectTemplate.content' })}
      />
      <View key={`tmpl-create-btn-box-${id}`} display="flex" justifyContent="start">
        <Button
          fontSize="T500"
          key={`tmpl-create-btn-${id}`}
          color="primary05"
          variant="tertiary"
          disabled={readonly}
          onClick={() => history.push(CREATE_CONTENT_PAGE)}
          css={{paddingLeft: 0}}
        >
          <FormattedMessage id="app.selectTemplate.orCreateANewContent" />
        </Button>
      </View>
    </>
  );
};

export default SelectTemplate;
